import { SocialProfilesAnalytics } from 'modules/Analyze/AnalyticsProvider';

export enum Metrics {
  'likes' = 'Likes',
  'comments' = 'Comments',
  'shares' = 'Shares'
}

export const getAvailableMetrics = (socialProfiles: SocialProfilesAnalytics[]): Metrics[] => {
  const availableMetricsForSelectedProfiles = Array.from(
    new Set(
      socialProfiles.flatMap(profile => {
        const profileTypename = profile.__typename;
        switch (profileTypename) {
          case 'FacebookSocialProfile':
            return [Metrics.likes, Metrics.comments, Metrics.shares];
          case 'TwitterSocialProfile':
            return [Metrics.likes, Metrics.shares];
          case 'LinkedInSocialProfile':
          case 'InstagramSocialProfile':
            return [Metrics.likes, Metrics.comments];
          case 'PinterestSocialProfile':
            return [Metrics.comments];
          default:
            return [];
        }
      })
    )
  );
  return availableMetricsForSelectedProfiles;
};
